function normalizeHeadingComparisonText(text: string): string {
  return text.trim().replace(/\s+/g, ' ').toLowerCase()
}

export function parseMarkdownHeadingLine(
  line: string
): { level: number; text: string } | null {
  const match = line.match(/^(#{1,6})\s+(.+)$/)
  if (match == null) {
    return null
  }
  return {
    level: match[1].length,
    text: match[2].trim(),
  }
}

/**
 * Remove a leading markdown heading when it repeats the section chrome title.
 */
export function stripRedundantSectionHeadingFromBody(
  markdown: string,
  sectionId: string,
  title: string
): string {
  const lines = markdown.split('\n')
  let index = 0

  while (index < lines.length && lines[index].trim() === '') {
    index += 1
  }

  if (index >= lines.length) {
    return markdown.trim()
  }

  const heading = parseMarkdownHeadingLine(lines[index])
  if (heading == null) {
    return markdown.trim()
  }

  const normalizedHeading = normalizeHeadingComparisonText(heading.text)
  const normalizedTitle = normalizeHeadingComparisonText(title)
  const normalizedFullHeading = normalizeHeadingComparisonText(
    title.trim().length > 0 ? `${sectionId} ${title}` : sectionId
  )
  const normalizedSectionId = normalizeHeadingComparisonText(sectionId)

  const repeatsSectionTitle =
    normalizedTitle.length > 0 && normalizedHeading === normalizedTitle
  const repeatsFullHeading = normalizedHeading === normalizedFullHeading
  const repeatsSectionIdOnly = normalizedHeading === normalizedSectionId

  if (!repeatsSectionTitle && !repeatsFullHeading && !repeatsSectionIdOnly) {
    return markdown.trim()
  }

  index += 1
  while (index < lines.length && lines[index].trim() === '') {
    index += 1
  }

  return lines.slice(index).join('\n').trim()
}
